import React, { Component } from "react";
import ReactMarkdown from "react-markdown";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withRouter, Link } from "react-router-dom";

import axios from "axios";
import { ContentfulClient, ApiConfig, API_URL } from "./../../settings";
import * as actions from "./../../actions/index";
import { selectStoryTags } from "./../../selectors.js";
import { animateScroll } from "react-scroll";

// Components
import "./style.css";
import MediumSpacer from "./../../components/MediumSpacer";
import BigSpacer from "./../../components/BigSpacer";
import SmallSpacer from "./../../components/SmallSpacer";
import LoadingBox from "./../../components/LoadingBox";
import FilterTag from "./../../components/FilterTag";
import HistoryPreviewBox from "./../../components/HistoryPreviewBox";
import ShareButtons from "./../../components/ShareButtons";

import StoryIcon from "./../../images/story.svg";
import { updateCanonicalLink } from "../../helpers/helpers.js";

// En enkelt småhistorie
class ShortStory extends Component {
    constructor() {
        super();

        this.state = {
            content: null,
            tags: null,
            connectedChurches: null,
            stories: null,
            error: false,
        };

        this.getStoryContent = this.getStoryContent.bind(this);
    }

    componentDidUpdate(prevProps) {
        const prevUrl = prevProps.match.params.id;
        const thisUrl = this.props.match.params.id;

        if (prevUrl !== thisUrl && thisUrl) {
            this.getStoryContent(thisUrl);
            animateScroll.scrollToTop({ duration: 300 });
        }
        if(this.state.content != null){
            this.updatePageMeta(this.state.content);
        }
    }

    componentDidMount() {
        this.getStoryContent(this.props.match.params.id);
        this.getStories();
        updateCanonicalLink();
    }

    updatePageMeta(content) {
        if (content.title){
            document.title = content.title;
            let titleOgTag = document.querySelector("meta[property='og:title']");
            titleOgTag.setAttribute('content', content.title);
        }  
    }
    getStoryContent(id) {
        axios
            .get(`${API_URL}/api/stories/${id}`, ApiConfig)
            .then((response) => {
                if (response.data.fields.hasOwnProperty("connectedTags")) {
                    this.setState({ tags: response.data.fields.connectedTags });
                }
                if (response.data.fields.hasOwnProperty("connectedChurch")) {
                    this.getConnectedChurch(response.data.fields.connectedChurch);
                }
                this.setState({
                    content: response.data.fields,
                    error: false,
                });
            })
            .catch((error) => {
                console.error(error);
                this.setState({ error: true });
            })
    }

    goToTag(id) {
        this.props.setTagsFilter([id]);
        this.props.history.push("/historier");
    }

    getConnectedChurch(connectedChurch) {
        let churches = [];

        connectedChurch.map((data) => {
            ContentfulClient.getEntry(data.sys.id)
                .then((res) => {
                    const historicalBuildingCode = res.sys.id;
                    return axios
                        .get(
                            `${API_URL}/api/churches/historicalBuildingCode/${historicalBuildingCode}`,
                            ApiConfig
                        )
                        .then((apiRes) => {
                            churches.push({ name: res.fields.name, id: apiRes.data.id });
                            this.setState({ connectedChurches: churches });
                        });
                })
                .catch((error) => {
                    console.error(error);
                });

            return null;
        });
    }

    getStories() {
        axios
            .get(`${API_URL}/api/stories?limit=${3}`, ApiConfig)
            .then((response) => {
                this.setState({
                    stories: response.data
                })
            })
            .catch((error) => {
                console.error(error);
            })
    }

    render() {
        const { content, tags, connectedChurches, stories, error } = this.state;
        const { storyTags } = this.props;

        if (error)
            return (
                <div className="container">
                    <MediumSpacer />
                    <p>Det oppstod en feil. Prøv å laste siden på nytt.</p>
                </div>
            );
        if (!content)
            return (
                <div>
                    <MediumSpacer />
                    <LoadingBox text="Laster småhistorien..." />
                </div>
            );

        return (
            <div className="short-story">
                <MediumSpacer />

                <div className="container">
                    <h1 className="short-story__page-title">{content.title}</h1>
                </div>

                {content.hasOwnProperty("featuredImage") && (
                    <div className="featured-image">
                        <div className="featured-image__inner">
                            <img
                                src={content.featuredImage}
                                alt="Uthevet bilde for småhistorien"
                            />
                        </div>
                    </div>
                )}

                <MediumSpacer />
                <ShareButtons />
                <MediumSpacer />

                <div className="container reading content-columns">
                    {content.hasOwnProperty("author") && (
                        <p className="short-story__author">
                            Tekst: {content.author}
                        </p>
                    )}
                    <ReactMarkdown source={content.body} />
                </div>

                {tags && storyTags && (
                    <div className="container reading">
                        <MediumSpacer />
                        <h4>Kategorisert under:</h4>
                        <SmallSpacer />

                        {tags.map(
                            (
                                data // Loop related tags and print them
                            ) => (
                                <FilterTag
                                    key={data.sys.id}
                                    onClick={() => this.goToTag(data.sys.id)}
                                    onKeyDown={() => this.goToTag(data.sys.id)}
                                    checked={undefined}
                                >
                                    {
                                        storyTags.find(
                                            (item) =>
                                                item.sys.id === data.sys.id
                                        ).fields.title
                                    }
                                </FilterTag>
                            )
                        )}
                    </div>
                )}
                <MediumSpacer />
                {connectedChurches && (
                    <div className="container reading">
                        <h4 className="short-story__small-title">
                            Tilknyttet kirkene:
                        </h4>
                        <ul className="inline-list">
                            {connectedChurches.map((data) => (
                                <li>
                                    <Link
                                        className="text-link"
                                        key={data.id}
                                        to={`/kirke/${data.id}`}
                                    >
                                        {data.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <BigSpacer />

                <div className="container">
                    <h2 className="page-title">
                        <img
                            className="page-title__icon"
                            src={StoryIcon}
                            alt="Ikon for andre historier"
                        />
                        Andre historier
                    </h2>
                    <div className="grid-column-3">
                        {stories &&
                            stories.map((data) => {
                                const img = data.fields.featuredImage;
                                const imageUrl = data.fields.hasOwnProperty(
                                    "featuredImage"
                                )
                                    ? `${img.substring(
                                        0,
                                        img.indexOf("?") !== -1
                                            ? img.indexOf("?")
                                            : img.length
                                    )}?w=400`
                                    : "https://placehold.co/400x300";

                                return (
                                    <HistoryPreviewBox
                                        key={data.sys.id}
                                        title={data.fields.title}
                                        link={`/historier/${data.sys.id}`}
                                        description={data.fields.body}
                                        image={imageUrl}
                                    />
                                );
                            })}
                    </div>
                </div>

                <MediumSpacer />
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    storyTags: selectStoryTags(),
});

const mapDispatchToProps = (dispatch) => {
    return {
        setTagsFilter: (filters) => dispatch(actions.setTagsFilter(filters)),
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ShortStory)
);



// WEBPACK FOOTER //
// ./src/containers/ShortStory/index.js